import React, { Component } from 'react'
import classNames from "classnames";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { compose } from "redux";
import { Droppable } from '../react-beautiful-dnd';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import MoveToInboxOutlinedIcon from '@material-ui/icons/MoveToInboxOutlined';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { withStyles } from '@material-ui/core';
import { styles } from '../../containers/dockPadStyle'

interface Props {
	classes: ClassNameMap;
    utilityTagsOpen: boolean;
}

type State = {
	
}

class _DragUtilityButtons extends Component<Props, State> {

    shouldComponentUpdate(nextProps :Props, nextState: State) {
        if(nextProps.utilityTagsOpen != this.props.utilityTagsOpen) {
            return true
        }


        return false
    }

    renderContent(){ 
        const { classes, utilityTagsOpen } = this.props
        return (
            <div className={classes.UtilityButtonsContainer} style={{ visibility:( !!utilityTagsOpen ? 'visible' : 'hidden')}}>
                <Droppable droppableId = 'delete'>
                    {(provided: { innerRef: string | ((instance: HTMLDivElement | null) => void) | React.RefObject<HTMLDivElement> | null | undefined; droppableProps: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement>; }) => (
                    <div
                        className={classes.CircularButtonContainer}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >						
                    <Button variant="outlined" color="secondary" size="small" onClick={this.handleCircularDelete} className={classes.CircularButton}> 
                        <div className={classes.UtilityButtonsIconContainer}>
                            <DeleteOutlineOutlinedIcon /> 
                            <p>Delete</p> 
                        </div>
                    </Button>
                    </div>
                )}
                </Droppable>

                
                <Droppable	droppableId = 'move'>
                    {(provided) => (
                        <div
                            className={classes.CircularButtonContainer}
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            <Button variant="outlined"  color="primary" size="small" onClick={this.handleCircularDrawerMove} className={classes.CircularButton}> 
                                <div className={classes.UtilityButtonsIconContainer}>
                                    <MoveToInboxOutlinedIcon /> 
                                    <p>To Backlog</p> 
                                </div>
                            </Button>
                        </div>
                )}
                </Droppable>
            </div>
        )
    }

    render() {
        return (
            <React.Fragment>
                {this.renderContent()}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state:any, ownProps?: any) => ({
    

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
    }
};

export const DragUtilityButtons = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),

)(_DragUtilityButtons)


// WEBPACK FOOTER //
// ./src/components/Lookahead/DragUtilityButtons.tsx